export default {
	// common locales
	"apikey.user-agent": "Label",
	"apikey.ip-address": "IP Address",
	"apikey.status": "Status",
	"apikey.status.valid": "VALID",
	"apikey.status.revoked": "REVOKED",
	"apikey.expiry": "Expire At",
	"apikey.created-at": "Created At",
	"apikey.created-title": "Successfully created new API Key",
	"apikey.created-subtitle": "This message will only be shown once. Please save your API Key and Secret somewhere secure.",
	"apikey.api-key": "API Key",
	"apikey.secret": "Secret",

	// page titles
	"apikey.page-description": "Create api keys for external applications. This should be used in your curl/wget/http-client commands with the HTTP headers: UPOS-API-KEY, UPOS-API-SIGNATURE, UPOS-API-TIMESTAMP. All requests should be HMAC signed with your generated Secret.",
	
	// placeholders / tooltips
	"apikey.search": "Search User Agent or IP Address",
	"apikey.add": "New API Key",
	"apikey.copy": "Copy API Key",
	"apikey.delete": "Delete API Key",
	"apikey.secret.copy": "Copy Secret",
	"apikey.copy.alert": "Copied API Key to clipboard",
	"apikey.secret.copy.alert": "Copied Secret to clipboard",

	// validation messages
	"apikey.user-agent.required": "Enter a name for this API Key",
	"apikey.ip-address.required": "What is the application's public IP Address?",
	"apikey.ip-address.pattern": "Invalid IP Address",

	// others
	"apikey.delete.prompt": "Are you sure you want to delete the API Key for",
};